module.exports = __webpack_public_path__ + "img/WEB .d02928f9.svg";